import StakeTabsButton from "./StakeTabsButton";
import { makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import Stake from "./Stake";
import Unstake from "./Unstake";
import Withdraw from "./Withdraw";
import { appConstants } from "../../utils";

const StakeTabs = () => {
  const classes = useStyles();

  const [selected, setSelected] = useState("Stake");
  const onChangeTab = (label: string) => {
    setSelected(label);
  };
  const showComponent = (selected: string) => {
    if (selected == "Stake") {
      return <Stake />;
    } else if (selected == "Unstake") {
      return <Unstake />;
    } else if (selected == "Withdraw") {
      return <Withdraw />;
    }
  };

  useEffect(() => {
    let textContent: HTMLTitleElement = document.querySelector("title")!;
    textContent.textContent = appConstants.APP_STAKE_PAGE_TITLE;
  }, []);

  return (
    <div>
      <div className={classes.container}>
        <div className={classes.nav}>
          <StakeTabsButton
            label={"Stake"}
            selected={selected}
            onChangeTab={onChangeTab}
          />

          <StakeTabsButton
            label={"Unstake"}
            selected={selected}
            onChangeTab={onChangeTab}
          />

          <StakeTabsButton
            label={"Withdraw"}
            selected={selected}
            onChangeTab={onChangeTab}
          />
        </div>

        {showComponent(selected)}
      </div>
    </div>
  );
};

export default StakeTabs;

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    marginBottom: "25px",
    flexDirection: "column",

    marginTop: "30px",
  },

  nav: {
    background: theme.palette.cardBgColor,

    border: theme.palette.border,
    borderRadius: "40px",
    display: "flex",
    padding: "5px",
    marginBottom: "25px",
    "@media(max-width:550px)": {
      marginRight: "20px",
      width: "95%",
      justifyContent: "center",
    },
  },
}));
